export class PartnerResponseModel {
    address: string;
    alias: string;
    country: string;
    email: string;
    gstNumber: string;
    id: string;
    city: string;
    mobile: string;
    name: string;
    state: string;
    ddInFavourOf: string;
    ddReferenceNumber: string;
    panNumber: string;
    hasVariableMargin: boolean;
    partnerStatus: string;
    partnerType: string;
    photo: string;
    pinCode: string;
    userFirstName: string;
    userLastName: string;
    wsflPrimaryBranchId: string;
    wsflRelationshipManagerId: string;
    thirdPartyPartnerId: number;
    sourcePartnerId: string;
    thirdPartyTourAgentId: number;
    thirdPartyCustomerId: number;
    billingCycle: number;
    billingCycleType: string;
    logoVisibility: string;
    productsInterestedIn: any = [];
    products: any = [];
    useLogoOnInvoice: boolean;
    considerGst: boolean;
    commissionInclusiveGst: boolean;
    invoiceRequired: boolean;
    tourOperatorReferrer: boolean;
    agentReferred: boolean;
    referringAgentsIds: any = [];
    referredByAgents: any = [];
    showFxCalculator: boolean;
    bulkOrderAllowed: boolean;
    actionSell: boolean;
    showRateRange: boolean;
    onlyAdditionalEmails?: boolean;
    widgetUrl?: string;
    additionalEmails?: string;
    utmLink?: string;
    isFXC?: boolean;
    fxcPartnerId?: number;
    fxcPartnerCardIssuers?: string[];
    sendCreationEmail: boolean;
    endDate: Date;
    excludeWsfx: boolean;
    onlyTourReferrers: boolean;
    startDate: Date;
    wsflReferenceBranchId: string;
    wsflPrimaryBranchName: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/partner/PartnerResponseModel.ts